import { useFilterOperators } from "../use-filter-operators";
import { useTransformSortParams } from "../use-transform-sort-params";
import { useMutation } from "react-query";
import eventEmitter from "../../events";
import { EVENT_AJAXING } from "../../data";
import { searchNewProducts } from "../../../components/search-tool/lib/searchData";
import { searchAdvancedFiltersFields } from "../../../components/task-list/lib/constants";

export const useNewSearch = (sourcePage, includeTrackingNumbers = false) => {
    const transformFilters = useFilterOperators(searchAdvancedFiltersFields);
    const transformSortParams = useTransformSortParams();

    return useMutation(({ searchParams, pagingParams, isUsingExternalFilters }) => {
        const params = pagingParams.reduce((param, { id, value }) => {
            // TODO: temporary, remove this when pagination will be unified
            if (id === "pageNumber") {
                value += 1;
            }

            return {
                ...param,
                [id]: value,
            };
        }, []);

        eventEmitter.emit(EVENT_AJAXING);

        return searchNewProducts(
            {
                PagingInfo: {
                    PageSize: parseInt(params["pageSize"]),
                    PageNumber: parseInt(params["pageNumber"]),
                },
                Filters: transformFilters(searchParams, isUsingExternalFilters),
                sortColumns: transformSortParams(params.originalSort || []),
            },
            sourcePage,
            includeTrackingNumbers
        );
    });
};
